import { createRouter, createWebHistory } from 'vue-router';
import HomeView from './views/HomeView.vue';
// import AboutView from './views/AboutView.vue';
// import ContactView from './views/ContactView.vue';
// import LegalView from './views/LegalView.vue';
import PageNotFound from './views/PageNotFound.vue';

const routes = [
  {
    path: '/',
    name: 'HomeView',
    component: HomeView,
  },
  // {
  //   path: '/about',
  //   name: 'AboutView',
  //   component: AboutView,
  // },
  // {
  //   path: '/contact',
  //   name: 'ContactView',
  //   component: ContactView,
  // },
  // {
  //   path: '/legal',
  //   name: 'LegalView',
  //   component: LegalView,
  // },
  {
    path: '/:pathMatch(.*)*',
    name: 'PageNotFound',
    component: PageNotFound,
  },
];

const router = createRouter({
  history: createWebHistory(),
  routes,
});

export default router;
